import { render, staticRenderFns } from "./AssignmentDetailsSkeleton.vue?vue&type=template&id=47a85041&scoped=true"
import script from "./AssignmentDetailsSkeleton.vue?vue&type=script&lang=js"
export * from "./AssignmentDetailsSkeleton.vue?vue&type=script&lang=js"
import style0 from "./AssignmentDetailsSkeleton.vue?vue&type=style&index=0&id=47a85041&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a85041",
  null
  
)

export default component.exports